import React from 'react'
import { SectionContainerLight } from '../common/sections/SectionContainerLight'
import { HeaderSection } from '../common/headers/HeaderSection'
import { CardRegistrationProcedur } from '../common/card/CardRegistrationProcedur'

export const SectionFreeCourseProcedure = () => {
    return (
        <SectionContainerLight id='free-course-procedure'>
            <HeaderSection title='Prosedur Pendaftaran' subtitle='Berikut Merupakan Prosedur Pendaftar' />
            <div className="flex flex-wrap px-8 md:px-16 pb-10">
                <div className='w-full flex flex-wrap  justify-center gap-x-6'>
                    <CardRegistrationProcedur order='1' title='Login / Sign Up' description='Jika belum memiliki akun, peserta perlu melakukan pembuatan akun. Jika sudah memiliki akun, peserta bisa langsung login' />
                    <CardRegistrationProcedur order="2" title="Pilih Program" description='Peserta wajib memilih program dan menuju formulir pendaftaran' />
                    <CardRegistrationProcedur order='3' title='Isi Formulir Pendaftaran' description='Peserta wajib melengkapi data diri dan pilihan program. Setelah mengisi formulir pendaftaran, jangan lupa klik kirim pendaftaran di bagian paling bawah formulir'/>
                    <CardRegistrationProcedur order='4' title='Tunggu dihubungi oleh panitia' description='Setelah itu, cek Email dan WhatsApp kamu secara berkala untuk mengetahui jalannya program' />
                </div>
            </div>
        </SectionContainerLight>
    )
}